require("jquery");
require("./main.ts");
